import { Ref, ref, unref, computed } from 'vue'
import { Sorting, Pagination } from '../../../data/pages/events'
import { CartEvent } from '../types'
import { v4 as uuid } from 'uuid'
import { useCartStore } from '../../../stores/cart-store'
import { removeFromCart } from '@/data/pages/cart'
import { shopService } from '@/services/shop-service'

export const useCart = () => {
  const isLoading = ref(false)
  const cartStore = useCartStore()

  const fetch = async () => {
    isLoading.value = true
    await cartStore.getAll({})
    isLoading.value = false
  }

  const checkout = async () => {
    isLoading.value = true

    try {
      const response = await shopService.checkout({})
      if (response.data.success) {
        isLoading.value = false //
        return { checkoutUrl: response.data.payload }
      } else {
        throw new Error(response.data.error)
      }
    } catch (error: any) {
      isLoading.value = false
      throw new Error(error.message)
    }
  }

  const cart = computed(() => {
    return cartStore.items
  })

  const totalPrice = computed(() => {
    return cartStore.items.reduce((acc, item) => acc + (item.price || 0), 0)
  })

  fetch()

  return {
    isLoading,
    totalPrice,
    cart,
    fetch,
    checkout,
    async addToCart(event: CartEvent) {
      isLoading.value = true
      await cartStore.add(event)
      await fetch()
      isLoading.value = false
    },

    async removeFromCart(event: CartEvent) {
      isLoading.value = true
      await cartStore.remove(event)
      await fetch()
      isLoading.value = false
    },

    async clearCart() {
      isLoading.value = true
      await cartStore.clear()
      isLoading.value = false
    },
  }
}
